import Tooltip from '@mui/material/Tooltip';
import React from 'react';

const CustomToolTip = ({title, placement, arrow, open, children, ...otherProps}) => {
  return (
    <Tooltip title={title} placement={placement} arrow={arrow} open={open} enterTouchDelay={0}>
      {children}
    </Tooltip>
  );
};

export default CustomToolTip;
